module.exports = __webpack_public_path__ + "img/checkbox-checked.f3a4d5703a5874363aaf2537ee34fec1.svg";